/** The per-product cost units an agent earns on (New + Renew + Setup + the ADO family). */
export const COMMISSION_AGENT_COST_UNITS = [
    'MAT New', 'ADM New', 'VSR New', 'PPDB New', 'MfRetail New',
    'MAT Renew', 'ADM Renew', 'VSR Renew', 'PPDB Renew', 'MfRetail Renew',
    'VSR Setup', 'ADAG', 'ADO', 'ADO+', 'ADOAD', 'ADODB', 'MfProfile', 'Other', 'Gegengeschäft',
];
export const COMMISSION_AGENT_CURRENCIES = ['EUR', 'USD'];
/** Running outstanding balance through and including `throughMonthId`, capped at
 *  `cap` on the top. The balance MAY go NEGATIVE (Aug 2026): negative = the agent
 *  gave back more than was drawn — a CREDIT in their favour they can consume in
 *  later months without going into debt with the company. */
export function agentDeltaBalanceThrough(byMonth, throughMonthId, cap) {
    let bal = 0;
    for (const mid of Object.keys(byMonth ?? {}).sort()) {
        if (mid > throughMonthId)
            break;
        bal = Math.min(cap, bal + (byMonth[mid] || 0));
    }
    return Math.round(bal * 100) / 100;
}
/** Direct source→target rate (target ∈ EUR/USD), or null if not set. */
export function agentDirectFxRate(direct, target, from, year, month1) {
    if (from === target)
        return 1;
    const y = direct?.find((d) => d.year === year);
    const table = target === 'EUR' ? y?.toEur : target === 'USD' ? y?.toUsd : undefined;
    const v = table?.[from]?.[month1 - 1];
    return typeof v === 'number' && v > 0 ? v : null;
}
/** Sample defaults from the source sheet (New/Renew/Setup); ADO family default 0 (override per agent). */
export const DEFAULT_COMMISSION_AGENT_RATES = {
    'MAT New': 0.3, 'ADM New': 0.25, 'VSR New': 0.5, 'PPDB New': 0.25, 'MfRetail New': 0.3,
    'MAT Renew': 0.07, 'ADM Renew': 0.07, 'VSR Renew': 0.14, 'PPDB Renew': 0.07, 'MfRetail Renew': 0.14,
    'VSR Setup': 0.5, 'ADAG': 0, 'ADO': 0, 'ADO+': 0, 'ADOAD': 0, 'ADODB': 0, 'MfProfile': 0, 'Other': 0, 'Gegengeschäft': 0,
};
export function resolveCommissionAgents(config) {
    return config?.commissionAgents ?? [];
}
export function resolveCommissionAgentRates(config) {
    const r = config?.commissionAgentRates;
    return { defaults: { ...DEFAULT_COMMISSION_AGENT_RATES, ...(r?.defaults ?? {}) }, overrides: r?.overrides ?? {} };
}
/** The rate for an agent × cost unit — per-agent override, else the default, else 0. */
export function commissionAgentRate(rates, agentKey, costUnit) {
    const o = rates.overrides?.[agentKey]?.[costUnit];
    if (typeof o === 'number')
        return o;
    const d = rates.defaults?.[costUnit];
    return typeof d === 'number' ? d : 0;
}
/** 'YYYY-MM' month id + label helpers. */
export function commissionAgentMonthId(year, month1) {
    return `${year}-${String(month1).padStart(2, '0')}`;
}
export function commissionAgentMonthLabel(monthId) {
    const [y, m] = monthId.split('-').map((n) => parseInt(n, 10));
    if (!y || !m)
        return monthId;
    return new Date(Date.UTC(y, m - 1, 1)).toLocaleDateString('en-GB', { month: 'long', year: 'numeric', timeZone: 'UTC' });
}
//# sourceMappingURL=commissionAgents.js.map